import React, { useState, useEffect, useRef } from 'react';
import './PieChart.scss';
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as d3 from "d3";
import Donut3D from "../../../library/Donut3D";

am4core.useTheme(am4themes_animated);

const PieChart = ({ data, identificador }) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [tooltipState, setTooltipState] = useState({ indiceToolTip: -1, openToolTip: false });
  const wrapperRef = useRef(null);
  const pieRef = useRef(null);

  const updateDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    setDimensions({ width, height });
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    document.addEventListener("mousedown", handleClickOutside);

    const salesData = data.map(item => ({
      name: item.name,
      value: item.value,
      color: item.color
    }));

    const svg = d3
      .select(pieRef.current)
      .append("svg")
      .attr("width", 700)
      .attr("height", 300);
    svg.append("g").attr("id", `quotesDonut${identificador}`);

    Donut3D().draw(`quotesDonut${identificador}`, salesData, 450, 160, 100, 60, 30, 0);

    return () => {
      window.removeEventListener("resize", updateDimensions);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [data, identificador]);

  const handleClickOutside = (event) => {
    if (tooltipState.indiceToolTip !== -1 && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setTooltipState({ indiceToolTip: -1, openToolTip: false });
    }
  };

  const toggleTooltip = (index, event) => {
    event.preventDefault();
    setTooltipState(prevState => ({
      indiceToolTip: prevState.indiceToolTip === index ? -1 : index,
      openToolTip: prevState.indiceToolTip !== index
    }));
  };

  const classPie = () => {
    if (data.length < 3) {
      return "content-draw-pie__regular";
    } else if (data.length > 2 && data.length < 4) {
      return "content-draw-pie__medium";
    } else {
      return "content-draw-pie__full";
    }
  };

  const simbol = (index) => {
    return tooltipState.indiceToolTip === index && tooltipState.openToolTip ? "+" : "+";
  };

  const toolTipRender = (index, data) => {
    if (tooltipState.indiceToolTip === index && tooltipState.openToolTip) {
      return (
        <div className={`conetnt-pop`}>
          <div className={`conetnt-pop-relative`}>
            <h3>{data.question}</h3>
            <p>{data.description}</p>
          </div>
        </div>
      );
    }
  };

  const showToolTip = (index) => {
    if (data[index].popPup) {
      return (
        <div className={`legend__btn-pop`}>
          <a
            href={"#!"}
            ref={wrapperRef}
            onClick={(event) => toggleTooltip(index, event)}
          >
            {simbol(index)}
          </a>
          {toolTipRender(index, data[index].popPup)}
        </div>
      );
    }
  };

  const classDistribution = data.length === 2 ? 'legend__row' : '';

  return (
    <section className={`content-draw-pie ${classPie()}`}>
      <div>
        <div className={`miGrafico${identificador}`}>
          <div
            className={`draw-pie${identificador}`}
            ref={pieRef}
          />
        </div>
      </div>
      <div className={`hide-logo`} />
      <div className={`legend ${classDistribution}`}>
        {data.map((item, index) => (
          <div key={index} className={`legend-item`}>
            <div
              className={`legend__color`}
              style={{ backgroundColor: item.color }}
            >
              <div
                className={`legend__color--triangle`}
                style={{ backgroundColor: item.color }}
              />
            </div>
            <div className={`legend__text`}>{item.name}</div>
            {showToolTip(index)}
          </div>
        ))}
      </div>
    </section>
  );
};

export default PieChart;